import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, Calendar, Users, Search } from "lucide-react";
import DatePicker from "@/components/DatePicker";
import api from "@/lib/api";
export default function SearchWidget({ compact = false, initial = {} }) {
  const nav = useNavigate();
  const today = new Date().toISOString().split("T")[0];
  const tomorrow = new Date(Date.now() + 864e5).toISOString().split("T")[0];
  const [destination, setDestination] = useState(initial.destination || "");
  const [checkin, setCheckin] = useState(initial.checkin || today);
  const [checkout, setCheckout] = useState(initial.checkout || tomorrow);
  const [guests, setGuests] = useState(initial.guests || 2);
  const [destinationsList, setDestinationsList] = useState(["Rishikesh", "Ukhimath", "Arambol", "Manali", "Kanatal"]);

  useEffect(() => {
    api.get("/destinations").then(r => {
      if (r.data && Array.isArray(r.data)) {
        setDestinationsList(r.data.map(d => d.name));
      }
    }).catch(() => {});
  }, []);

  const submit = (e) => {
    e?.preventDefault?.();
    const p = new URLSearchParams({ destination, checkin, checkout, guests: String(guests) });
    nav(`/search?${p.toString()}`);
  };

  return (
    <form onSubmit={submit} className="search-pill" data-testid="search-widget">
      <div>
        <div className="ols-label flex items-center gap-1.5"><MapPin className="w-3 h-3" /> Where</div>
        <input data-testid="search-destination" list="ols-destinations" value={destination} onChange={(e) => setDestination(e.target.value)} placeholder="Location, City" className="mt-1" />
        <datalist id="ols-destinations">
          {destinationsList.map((d) => <option key={d} value={d} />)}
        </datalist>
      </div>
      <div>
        <div className="ols-label flex items-center gap-1.5"><Calendar className="w-3 h-3" /> Check-in</div>
        <DatePicker value={checkin} onChange={setCheckin} minDate={today} placeholder="Add date" testid="search-checkin" className="mt-1" />
      </div>
      <div>
        <div className="ols-label flex items-center gap-1.5"><Calendar className="w-3 h-3" /> Check-out</div>
        <DatePicker value={checkout} onChange={setCheckout} minDate={checkin || today} placeholder="Add date" testid="search-checkout" className="mt-1" />
      </div>
      <div>
        <div className="ols-label flex items-center gap-1.5"><Users className="w-3 h-3" /> Guests</div>
        <input data-testid="search-guests" type="number" min={1} max={20} value={guests} onChange={(e) => setGuests(+e.target.value)} className="mt-1" />
      </div>
      <div className="flex search-btn-wrap">
        <button type="submit" className="w-full md:w-auto md:m-0 px-6 py-3 md:py-3 bg-stone-900 text-white rounded-full font-semibold text-sm hover:bg-stone-700 flex items-center justify-center gap-2 whitespace-nowrap" data-testid="search-submit">
          <Search className="w-4 h-4" /> Search
        </button>
      </div>
    </form>
  );
}
